import { render } from "./InventoryManager.vue?vue&type=template&id=c5fd4a96&scoped=true"
import script from "./InventoryManager.vue?vue&type=script&lang=js"
export * from "./InventoryManager.vue?vue&type=script&lang=js"

import "./InventoryManager.vue?vue&type=style&index=0&id=c5fd4a96&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5fd4a96"]])

export default __exports__